import type { DnBtnSize } from '../../dn-primary-btn/dn-primary-btn.config';

export enum MarketingSize {
  Marketing = 'marketing',
}

export type MarketingBtnSize = DnBtnSize | MarketingSize;
